// ============================================================================
// LEDGER MAPPING ENDPOINTS (Fairbooks integration configuration)
// ============================================================================

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/ledger-mappings';

export const ledgerMappingEndpoints = {
  /** Static dropdown vocabularies (source types, roles, payment modes, ...). */
  lookups: () => buildEndpoint(`${BASE_PATH}/lookups`),
  /** Live Fairbooks chart of accounts for the ledger picker (proxied by CRS). */
  fbLedgers: () => buildEndpoint(`${BASE_PATH}/fb-ledgers`),

  // Resolver rows (bank account / role -> Fairbooks ledger)
  list: () => buildEndpoint(BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  create: () => buildEndpoint(BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  // Transaction mappings (voucher type + legs)
  transactionMaps: () => buildEndpoint(`${BASE_PATH}/transaction-maps`),
} as const;

export default ledgerMappingEndpoints;
